import { comparePrimitives, equals, int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import * as react from "react";
import { toString } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { pagination, errorMsg, spinner, icon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { Page, Msg } from "./Types.fs.js";
import { DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Http_downloadMetadataUrl, Http_downloadUrl } from "./State.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty as empty_1, sort, map } from "../../../fable_modules/fable-library-js.4.19.0/List.js";

export function tableRow(dispatch, file) {
    let children, children_6, children_8, children_18;
    const aktiv = file.IsHidden ? "deaktiviert" : "";
    const children_20 = [(children = [int32ToString(file.Kundennummer)], react.createElement("td", {}, ...children)), react.createElement("td", {}, file.Kategorie), (children_6 = [file.Titel, react.createElement("br", {}), react.createElement("div", {
        className: "is-size-7",
    }, file.Filename)], react.createElement("td", {}, ...children_6)), (children_8 = [toString(file.Datum, "dd.MM.yyyy")], react.createElement("td", {}, ...children_8)), (children_18 = toList(delay(() => {
        let children_10, children_12;
        return append(file.IsHidden ? singleton((children_10 = [icon("fas fa-eye")], react.createElement("a", {
            onClick: (_arg) => {
                dispatch(new Msg(6, [file.Id, file.Type]));
            },
            title: "aktivieren",
        }, ...children_10))) : singleton((children_12 = [icon("fas fa-eye-slash")], react.createElement("a", {
            onClick: (_arg_1) => {
                dispatch(new Msg(7, [file.Id, file.Type]));
            },
            title: "deaktivieren",
        }, ...children_12))), delay(() => {
            let props_16;
            return append(singleton((props_16 = [new HTMLAttr(65, ["download-icon fas fa-file-download"]), new HTMLAttr(158, ["herunterladen"]), new HTMLAttr(94, [Http_downloadUrl(file)])], react.createElement("a", keyValueList(props_16, 1)))), delay(() => {
                let props_18;
                return file.HasMetadata ? singleton((props_18 = [new HTMLAttr(65, ["download-icon fas fa-file-csv"]), new HTMLAttr(158, ["Inhaltsverzeichnis herunterladen"]), new HTMLAttr(94, [Http_downloadMetadataUrl(file)])], react.createElement("a", keyValueList(props_18, 1)))) : empty();
            }));
        }));
    })), react.createElement("td", {}, ...children_18))];
    return react.createElement("tr", {
        className: aktiv,
    }, ...children_20);
}

export function table(files, dispatch) {
    let children_12, children_10, children_14;
    const children_16 = [(children_12 = [(children_10 = [react.createElement("th", {}, "Kunde"), react.createElement("th", {}, "Kategorie"), react.createElement("th", {}, "Titel & Dateiname"), react.createElement("th", {}, "Datum"), react.createElement("th", {}, "Aktionen")], react.createElement("tr", {}, ...children_10))], react.createElement("thead", {}, ...children_12)), (children_14 = map((file) => tableRow(dispatch, file), files), react.createElement("tbody", {}, ...children_14))];
    return react.createElement("table", {
        className: "table table-striped responsive-table",
    }, ...children_16);
}

export function listPage(model, dispatch, navigateTo) {
    let children_34;
    const patternInput = (model.Kundennummer == null) ? ["", "is-outlined"] : ["is-outlined", ""];
    const children_36 = [(children_34 = toList(delay(() => {
        let children_32, children_30;
        return append(singleton((children_32 = [(children_30 = toList(delay(() => {
            let children_24, children_10, children_2, props, children_4, children_8, props_8, children_22, children_20, children_18;
            return append(singleton((children_24 = [(children_10 = [(children_2 = [(props = [new HTMLAttr(65, ["button is-link is-small is-rounded is-info " + patternInput[0]]), new DOMAttr(40, [(_arg) => {
                dispatch(new Msg(3, []));
            }])], react.createElement("button", keyValueList(props, 1), "alle Kunden"))], react.createElement("p", {
                className: "control",
            }, ...children_2)), (children_4 = [react.createElement("input", {
                className: "input is-info is-small",
                type: "text",
                placeholder: "Kundennummer",
                value: model.KundennummernFilterText,
                onChange: (ev) => {
                    dispatch(new Msg(2, [ev.target.value]));
                },
                onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        dispatch(new Msg(4, []));
                    }
                },
            })], react.createElement("div", {
                className: "control",
            }, ...children_4)), (children_8 = [(props_8 = [new HTMLAttr(65, ["button is-info is-small is-rounded " + patternInput[1]]), new DOMAttr(40, [(_arg_1) => {
                dispatch(new Msg(4, []));
            }]), new HTMLAttr(79, [!model.KundennummernFilterEnabeld])], react.createElement("a", keyValueList(props_8, 1), "nur eine Kundennummer"))], react.createElement("div", {
                className: "control",
            }, ...children_8))], react.createElement("div", {
                className: "field has-addons",
            }, ...children_10)), react.createElement("div", {
                className: "hspacer",
            }), (children_22 = [(children_20 = [(children_18 = toList(delay(() => {
                let props_16;
                return append(singleton((props_16 = [new HTMLAttr(161, [""]), new HTMLAttr(143, [equals(model.Kategorie, undefined)])], react.createElement("option", keyValueList(props_16, 1), "alle Kategorien"))), delay(() => map((s_3) => {
                    const props_18 = [new HTMLAttr(161, [s_3]), new HTMLAttr(143, [equals(model.Kategorie, s_3)])];
                    return react.createElement("option", keyValueList(props_18, 1), s_3);
                }, sort(model.AllKategorien, {
                    Compare: comparePrimitives,
                }))));
            })), react.createElement("select", {
                className: "input has-background-info has-text-white is-info is-small is-rounded",
                onChange: (ev_1) => {
                    const matchValue_1 = ev_1.target.value;
                    if (matchValue_1 === "") {
                        dispatch(new Msg(5, [undefined]));
                    }
                    else {
                        dispatch(new Msg(5, [matchValue_1]));
                    }
                },
            }, ...children_18))], react.createElement("div", {
                className: "control",
            }, ...children_20))], react.createElement("div", {
                className: "field has-addons",
            }, ...children_22))], react.createElement("div", {
                className: "field is-grouped",
            }, ...children_24))), delay(() => {
                let matchValue_2;
                return singleton((matchValue_2 = model.Files, (matchValue_2.tag === 1) ? spinner : ((matchValue_2.tag === 2) ? errorMsg("Fehler beim Laden der Dateien!") : ((matchValue_2.tag === 3) ? (equals(matchValue_2.fields[0].Items, empty_1()) ? react.createElement("div", {}, "Keine Dateien vorhanden") : table(matchValue_2.fields[0].Items, dispatch)) : react.createElement("div", {})))));
            }));
        })), react.createElement("div", {
            className: "card-body",
        }, ...children_30))], react.createElement("div", {
            className: "flat-card profile-info-card is-auto",
        }, ...children_32))), delay(() => {
            const matchValue_3 = model.Files;
            if (matchValue_3.tag === 3) {
                return singleton(pagination(matchValue_3.fields[0], (page) => {
                    navigateTo(new Page(page, model.Kundennummer, model.Kategorie));
                }));
            }
            else {
                return empty();
            }
        }));
    })), react.createElement("div", {
        className: "column is-12",
    }, ...children_34))];
    return react.createElement("div", {
        className: "columns is-multiline",
    }, ...children_36);
}

export function view(model, dispatch, navigateTo) {
    return listPage(model, dispatch, (arg) => {
        navigateTo(arg);
    });
}

//# sourceMappingURL=View.fs.js.map
